import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  MenuItem,
  Grid,
  FormControl,
  Select,
  Checkbox,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import ndcBg from "../../assets/images/ndc-bg.png";
import closeIcon from "../../assets/images/close.png";
import searchIcon from "../../assets/images/search.svg";
import arrowDown from "../../assets/images/arrow-down.png";
import alertCircle from "../../assets/images/alert-circle.svg";
import ErrorIcon from "@mui/icons-material/Error";

const CustomModal = ({
  open,
  handleClose,
  title,
  fields,
  showInputs,
  infoText,
  submitButtonText,
  // submitButtonDisabled,
  handleSubmit,
  handleDeleteMarket,
  showSubmit,
  showCancel,
  showNotif,
  notifText,
  check,
  type,
  cancelButtonText,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [openDropdown, setOpenDropdown] = useState({});

  const [cancelNotif, setCancelNotif] = useState(false);

  const [errors, setErrors] = useState({});
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);

  const toggleDropdown = (index, isOpen) => {
    setOpenDropdown((prev) => ({
      ...prev,
      [index]: isOpen, // Toggle the open state for the specific dropdown
    }));
  };

  const validateFields = () => {
    const newErrors = {};
    fields.forEach((field) => {
      if (
        !field.value ||
        (Array.isArray(field.value) && field.value.length === 0)
      ) {
        newErrors[field.label] = "This field is mandatory";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  React.useEffect(() => {   
    // if (open) {
    //   setCancelNotif(true);
    // }
    const allFieldsFilled = fields.every(
      (field) =>{
        if (field.type === "comment") {
        return field.value && field.value.trim().length > 0;
      }
      return field.value && (!Array.isArray(field.value) || field.value.length > 0);
    });
    setSubmitButtonDisabled(type !== "delete" && !allFieldsFilled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields, type]);

  const handleSubmitWithValidation = () => {
    if (type === "add" && validateFields()) {
      if (check) {
        setCancelNotif(false);
      }
      handleSubmit(type); // Call the original handleSubmit if validation passes
    } else if (type === "edit" && validateFields()){
      if (check) {
        setCancelNotif(false);
      }
      handleSubmit(type);
      // handleSubmit(); // Call the original handleSubmit if validation passes
    } else if (type === "delete") {
      const commentField = fields.find((field) => field.type === "comment");
      if (commentField && (!commentField.value || !commentField.value.trim())) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [commentField.label]: "Comment is required before proceeding.",
        }));
        return; // Stop further execution if validation fails
      }
      handleDeleteMarket(); // Call the delete function if type is "delete"
    }
  };

  const handleCloseModal = () => {
    // setCancelNotif(false); // Reset the cancelNotif state
    handleClose(); // Call the parent-provided close handler
  };

  return (
    <Modal open={open} onClose={handleCloseModal} sx={{}}>
      <Box
        sx={{
          position: "absolute",
          top: "60%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          // height: "39.4rem",
          maxHeight: "90vh",
          overflowY: "auto",
          width: "55rem",
          borderRadius: "1rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            background: `url(${ndcBg})`,
            minHeight: "8rem",
            borderRadius: "1rem",
            backgroundRepeat: "round",
            px: "2rem",
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            sx={{
              fontSize: "2.25rem",
              fontWeight: 700,
              lineHeight: "3rem",
              fontFamily: "Open Sans",
            }}
          >
            {title}
          </Typography>
          <IconButton
            onClick={handleCloseModal}
            sx={{ height: "2.5rem", width: "2.5rem" }}
          >
            <img src={closeIcon} alt="close icon" />
          </IconButton>
        </Box>
        <Grid
          container
          columnSpacing={"1.5rem"}
          spacing={"2.5rem"}
          sx={{
            px: "2rem",
            py: "2.25rem",
          }}
        >
          {showInputs ? (
            fields.map((field, index) => {
              if (field.type === "input") {
                return (
                  <Grid item xs={12} md={6} lg={6} key={field.label || index}>
                    <TextField
                      variant="standard"
                      key={index}
                      label={field.label}
                      value={field.value}
                      onChange={field.onChange}
                      fullWidth
                      margin="normal"
                      error={!!errors[field.label]}
                      helperText={errors[field.label]}
                    />
                  </Grid>
                );
              } else if (field.type === "dropdown") {
                const filteredOptions = field?.options?.filter(
                  (item) =>
                    !searchTerm.trim().length ||
                    item.label.toLowerCase().includes(searchTerm.toLowerCase())
                );
                return (
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl
                      fullWidth
                      error={!!errors[field.label]}
                      sx={{
                        "& .MuiInputBase-root": {
                          mt: ".5rem",
                        },
                        "& .MuiInputBase-root:after": {
                          borderBottom: "2px solid #1460AA",
                        },
                        "& .MuiInputBase-root.Mui-error:after": {
                          borderBottom: "2px solid #851109",
                        },
                      }}
                    >
                      <InputLabel
                        sx={{
                          // fontSize: ".75rem",
                          color: "#000000",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          fontSize: "16px",
                          lineHeight: "20px",
                          marginLeft: "-.75rem",
                          "&.Mui-focused": {
                            color: "#717173",
                          },
                          "&.Mui-error": {
                            color: "#000",
                          },
                        }}
                      >
                        {field.label}
                      </InputLabel>

                      <Select
                        autoComplete={"off"}
                        autoFocus={false}
                        open={!!openDropdown[index]}
                        IconComponent={(props) => (
                          <img
                            {...props}
                            style={{
                              position: "absolute",
                              top: ".25rem",
                              right: ".5rem",
                            }}
                            src={arrowDown}
                            alt="arrow down"
                          />
                        )}
                        onOpen={() => toggleDropdown(index, true)}
                        onClose={() => {
                          toggleDropdown(index, false);
                          setSearchTerm("");
                        }}
                        onClick={(e) => e.stopPropagation()}
                        fullWidth
                        variant="standard"
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: "28rem",
                              overflowY: "hidden",
                              borderRadius: "0 0 1rem 1rem",
                            },
                          },
                        }}
                        value={field.value}
                        onChange={field.onChange}
                        renderValue={(selected) =>
                          field.options?.find((item) => item.value === selected)
                            ?.label
                        }
                      >
                        <TextField
                          fullWidth
                          value={searchTerm}
                          autoComplete={"off"}
                          autoFocus={true}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          sx={{
                            border: "none",
                            position: "sticky",
                            top: 0,
                            background: "#fff",
                            zIndex: 2,
                            "& input": {
                              height: "2.5rem !important",
                              p: "1rem",
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              fontFamily: "Open Sans",
                              lineHeight: "1.5rem",
                            },
                            "& .MuiSelect-root": {
                              borderBottom: "unset",
                            },
                            "& .MuiInputBase-root": {
                              // borderBottom: "1px solid #1460AA",
                              "&:after": {
                                borderBottom: "1px solid #1460AA",
                              },
                            },
                          }}
                          variant="standard"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                sx={{ mr: "1rem" }}
                                position="end"
                              >
                                <img src={searchIcon} alt="searchImg" />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Box sx={{ maxHeight: "24.5rem", overflowY: "auto" }}>
                          {filteredOptions.map((item) => (
                            <MenuItem
                              key={item.value}
                              value={item.value}
                              onClick={(e) => {
                                field.onChange({
                                  target: {
                                    value: item.value,
                                  },
                                });
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  [field.label]: undefined, // Clear the error for this field
                                }));
                                toggleDropdown(index, false);
                                setTimeout(() => setSearchTerm(""), 700);
                              }}
                            >
                              <Box
                                sx={{
                                  height: "3.5rem",
                                  dislay: "flex",
                                  flexDirection: "column",
                                  alignContent: "center",
                                  fontSize: "0.875rem",
                                  fontFamily: "Open Sans",
                                  lineHeight: "1.5rem",
                                }}
                              >
                                <Checkbox
                                  checked={field.value?.includes(item.value)}
                                  sx={{ color: "#1460AA" }}
                                // checked={field.value.includes(item.value)}
                                />
                                {item.label}
                              </Box>
                            </MenuItem>
                          ))}
                        </Box>
                      </Select>
                      {errors[field.label] && (
                        <Typography
                          sx={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            lineHeight: '16px',
                            color: "#851109",
                            fontSize: "0.75rem",
                            mt: "0.25rem",
                          }}
                        >
                          <ErrorIcon
                            sx={{
                              width: "13.3px",
                              height: "13.3px",
                              color: "#851109",
                              mr: "10px"
                            }}
                          />
                          {errors[field.label]}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                );
              } else if (field.type === "multidropdown") {
                const filteredOptions = field.options.filter(
                  (item) =>
                    !searchTerm.trim().length ||
                    item.label.toLowerCase().includes(searchTerm.toLowerCase())
                );

                return (
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl
                      fullWidth
                      error={!!errors[field.label]}
                      sx={{
                        "& .MuiInputBase-root": {
                          mt: ".5rem",
                        },
                      }}
                    >
                      <InputLabel
                        sx={{
                          // fontSize: ".75rem",
                          color: "#000000",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          fontSize: "16px",
                          lineHeight: "20px",
                          marginLeft: "-.75rem",
                          "&.Mui-focused": {
                            color: "#717173",
                          },
                          "&.Mui-error": {
                            color: "#000",
                          },
                        }}
                      >
                        {field.label}
                      </InputLabel>

                      <Select
                        onClose={() => {
                          setTimeout(() => setSearchTerm(""), 700);
                        }}
                        multiple
                        onKeyDown={(e) => e.stopPropagation()}
                        IconComponent={(props) => (
                          <img
                            {...props}
                            style={{
                              position: "absolute",
                              top: ".25rem",
                              right: ".5rem",
                            }}
                            src={arrowDown}
                            alt="arrow down"
                          />
                        )}
                        autoFocus={false}
                        inputProps={{
                          autoFocus: false,
                        }}
                        autoComplete={"off"}
                        // value={field.value}
                        value={Array.isArray(field.value) ? field.value : []}
                        fullWidth
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: "28rem",
                              overflowY: "hidden",
                              borderRadius: "0 0 1rem 1rem",
                            },
                          },
                        }}
                        variant="standard"
                        onChange={field.onChange}
                        renderValue={(selected) => {
                          const selectedArray = Array.isArray(selected) ? selected : [];
                          return (
                            <div style={{ fontSize: ".875rem" }}>
                              {selectedArray
                                .filter((item) => item.trim())
                                .map(
                                  (item) =>
                                    field.options.find(
                                      (el) => el.value === item
                                    )?.label
                                )
                                .join(", ")}
                            </div>
                          );
                        }}
                      >
                        <TextField
                          fullWidth
                          value={searchTerm}
                          autoComplete={"off"}
                          autoFocus={true}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          sx={{
                            border: "none",
                            position: "sticky",
                            top: 0,
                            background: "#fff",
                            zIndex: 2,
                            "& input": {
                              height: "2.5rem !important",
                              p: "1rem",
                              fontWeight: 600,
                              fontSize: "0.875rem",
                              fontFamily: "Open Sans",
                              lineHeight: "1.5rem",
                            },
                            "& .MuiSelect-root": {
                              borderBottom: "unset",
                            },
                            "& .MuiInputBase-root": {
                              // borderBottom: "1px solid #1460AA",
                              "&:after": {
                                borderBottom: "1px solid #1460AA",
                              },
                            },
                          }}
                          variant="standard"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                sx={{ mr: "1rem" }}
                                position="end"
                              >
                                <img src={searchIcon} alt="searchImg" />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <Box sx={{ maxHeight: "24.5rem", overflowY: "auto" }}>
                          {filteredOptions.map((item) => (
                            <MenuItem
                              key={item.label}
                              value={item.value}
                              onClick={(e) => {
                                field.onChange({
                                  target: {
                                    value: field.value.includes(item.value)
                                      ? field.value.filter(
                                        (i) => i !== item.value
                                      )
                                      : [...field.value, item.value],
                                  },
                                });
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  [field.label]: undefined, // Clear the error for this field
                                }));
                              }}
                            >
                              <Box
                                sx={{
                                  height: "3.5rem",
                                  dislay: "flex",
                                  flexDirection: "column",
                                  alignContent: "center",
                                  fontSize: "0.875rem",
                                  fontFamily: "Open Sans",
                                  lineHeight: "1.5rem",
                                }}
                              >
                                <Checkbox
                                  checked={field.value?.includes(item.value)}
                                  sx={{ color: "#1460AA" }}
                                // checked={field.value.includes(item.value)}
                                />
                                {item.label}
                              </Box>
                            </MenuItem>
                          ))}
                        </Box>
                      </Select>
                      {errors[field.label] && (
                        <Typography
                          sx={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            lineHeight: '16px',
                            color: "#851109",
                            fontSize: "0.75rem",
                            mt: "0.25rem",
                          }}
                        >
                          <ErrorIcon
                            sx={{
                              width: "13.3px",
                              height: "13.3px",
                              color: "#851109",
                              mr: "10px"
                            }}
                          />
                          {errors[field.label]}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                );
              } else if (field.type === "display") {
                const DisplayMsg = field.value;
                return (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography
                      key={index}
                      sx={{
                        fontSize: "1.125rem",
                        lineHeight: "1.5rem",
                        fontWeight: 600,
                      }}
                    >
                      <DisplayMsg />
                    </Typography>
                  </Grid>
                );
              } else if (field.type === "comment") {
                return (
                  <Grid item xs={12}>
                    <InputLabel
                      sx={{
                        lineHeight: "1.25rem",
                        fontWeight: "bold",
                        fontFamily: "Open Sans",
                        fontSize: "1rem",
                        color: "#000000",
                      }}
                    >
                      Comment
                    </InputLabel>
                    <TextField
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e); // Update the field value
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          [field.label]: undefined, // Clear the error for this field
                        }));
                      }}
                      fullWidth
                      placeholder={field.placeholder}
                      error={!!errors[field.label]}
                      helperText={
                        errors[field.label] && (
                          <Box sx={{ display: "flex", alignItems: "center", color: "#851109" }}>
                            <ErrorIcon sx={{ width: "13.3px", height: "13.3px", marginRight: "10px" }} />
                            {errors[field.label]}
                          </Box>
                        )
                      }
                      multiline
                      rows={4}
                      variant="outlined"
                      inputProps={{
                        style: {
                          fontSize: ".875rem",
                          lineHeight: "1.25rem",
                        },
                      }}
                      sx={{
                        mt: "1rem",
                        "& .MuiInputBase-input::placeholder": {
                          color: "#717173",
                          fontSize: ".875rem",
                          lineHeight: "1.25rem",
                        },
                      }}
                    />
                  </Grid>
                );
              }
              return null;
            })
          ) : (
            <Typography variant="body1">{infoText}</Typography>
          )}

          <Grid
            item
            display="flex"
            xs={12}
            justifyContent={
              cancelNotif && !showCancel ? "flex-end" : "space-between"
            }
            alignItems={"center"}
          >
            {showCancel && (
              <Button
                variant="contained"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  // color: "#1460AA",
                  display: "flex",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "20px",
                  height: "41px",
                  minWidth: "120px",
                  pl: "25px",
                  pr: "25px",
                  borderRadius: "24px",
                  background: "#1460AA",
                }}
              >
                {cancelButtonText}
              </Button>
            )}

            {showNotif && !cancelNotif && check && (
              <Typography
                sx={{
                  border: ".5px solid #B83A32",
                  p: "1rem",
                  borderRadius: "1rem",
                  bgcolor: "#FFF1F0",
                  display: "flex",
                  alignItems: "center",
                  height: "1.5rem",
                }}
              >
                <img
                  src={alertCircle}
                  alt="alert-cirlce"
                  style={{ marginRight: "1rem", display: "flex" }}
                />{" "}
                {notifText}
                <IconButton
                  sx={{ ml: "1rem" }}
                  onClick={() => setCancelNotif(true)}
                >
                  <img src={closeIcon} alt="cancel-notif" />
                </IconButton>
              </Typography>
            )}

            {showSubmit && (
              <Button
                variant="contained"
                disabled={submitButtonDisabled}
                onClick={handleSubmitWithValidation}
                sx={{
                  textTransform: "none",
                  // color: "#1460AA",
                  display: "flex",
                  // justifyContent: "end",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "20px",
                  height: "41px",
                  minWidth: "120px",
                  pl: "25px",
                  pr: "25px",
                  borderRadius: "24px",
                  color: type !== "delete" ? "#fff" : "#1460AA",
                  background: type === "delete" ? "#fff" : "#1460AA",
                  boxShadow: "none",
                  marginLeft: "auto",
                  ...(type === "delete" && { border: "1px solid #1460AA" }),
                  "&:hover": {
                    background: type === "delete" ? "#fff" : "#1460AA",
                  },
                }}
              >
                {submitButtonText}
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CustomModal;
